exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._13U6AQM4NVKZrq{display:inline}.bsz48qOcQ3gWGd{flex-direction:column}._3La-mBxAhKN_Eq{margin-top:5px;font-size:20px}", ""]);

// exports
exports.locals = {
	"smallTeamBoardsBanner": "_13U6AQM4NVKZrq",
	"boardsMenuBanner": "bsz48qOcQ3gWGd",
	"boardsMenuBannerEmoji": "_3La-mBxAhKN_Eq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/member/team-boards-cta/small-team-boards-cta-banner.less
// module id = G606
// module chunks = 24